import { formatDate } from "@/utils";
import { Chip, Stack } from "@mui/material";
import { FC } from "react";
import { ChatDateSeparatorProps } from "./chat-date-separator.types";

const ChatDateSeparator: FC<ChatDateSeparatorProps> = ({ date }) => {
  return (
    <Stack direction="row" width="100%" justifyContent="center">
      <Chip
        variant="outlined"
        color="primary"
        label={formatDate(date, "MMM DD, YYYY")}
        sx={{ width: "fit-content" }}
      />
    </Stack>
  );
};

export { ChatDateSeparator };
